/**
 * Chip copy hygiene (2026-08-23 field report).
 *
 * A live detection produced the chip "bathroom vanity" — lower-case, padded with the room the
 * homeowner had just photographed. The server sanitises new detections; this does the same at
 * the last moment before pixels, so every mask already in the database reads properly too.
 */

const NOISE_WORDS = new Set([
  'a',
  'an',
  'the',
  'bathroom',
  'kitchen',
  'room',
  'basement',
  'exterior',
])

export function prettyLabel(raw: string): string {
  const words = raw.split(/[\s_.]+/).filter((word) => word && !NOISE_WORDS.has(word.toLowerCase()))
  const name = (words.join(' ').trim() || raw.trim() || 'Item').slice(0, 40)
  return name === name.toLowerCase() ? name.charAt(0).toUpperCase() + name.slice(1) : name
}
